import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, computed } from '../../../../../adapter-vue';
import { IImageMessageContent } from '../../../../../interface';
interface IProps {
  messageContent: Record<string, unknown> | IImageMessageContent | undefined;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'message-abstract-image',
  props: {
    messageContent: { default: () => ({}) as IImageMessageContent }
  },
  setup(__props: any) {

const props = __props as { messageContent: Record<string, unknown> | IImageMessageContent | undefined }



const imageUrl = computed<string>(() => (props.messageContent as IImageMessageContent).url || '');

return { __sfc: true,props, imageUrl }
}

})